import Skeleton from "react-loading-skeleton";

export const SuggestedProductCardSkeleton = () => {
  return (
    <>
      {[...Array(4)].map((_, index) => (
        <div
          key={index}
          className="gg-h-36 sm:gg-h-80 md:gg-w-72 lg:gg-w-56 gg-w-full xl:gg-h-96 xl:gg-w-64"
        >
          <Skeleton className="flex-1 gg-w-full gg-h-full" />
        </div>
      ))}
    </>
  );
};
